import { render, staticRenderFns } from "./medicalReportDetails.vue?vue&type=template&id=716195aa"
import script from "./medicalReportDetails.vue?vue&type=script&lang=js"
export * from "./medicalReportDetails.vue?vue&type=script&lang=js"
import style0 from "./medicalReportDetails.vue?vue&type=style&index=0&id=716195aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports